<template>
    <div class="site-footer">
        <div class="container">
            <div class="row">
                <div class="link clearfix" :class="{hide: isMobile}" ref="links">
                    <!-- <a v-for="(item, idx) in links" :key="idx" :href="item.href" :id="item.text">{{ $t(item.text) }}</a> -->
                    <a href="https://www.eyougame.com/v2/about/">{{ $t('about_us') }}</a>
                    <a href="https://www.eyougame.com/v2/privacy/">{{ $t('private_policy') }}</a>
                    <a href="https://www.eyougame.com/v2/service/">{{ $t('terms_of_service') }}</a>
                    <a v-if="!g.arraign" href="https://www.eyougame.com/v2/cus/#10734">{{ $t('customer_service') }}</a>
                    <a @click="scrollToTop">{{ $t('back_to_top') }}</a>
                </div>
            </div>
            <div class="copyright">
                <img class="eyougame-logo" src="../assets/img/eyougame.png">
                <p>COPYRIGHT © Eyou Technology Pte Ltd</p>
                <p>ALL RIGHTS RESERVED</p>
            </div>
        </div>
    </div>
</template>

<script>
/*
 * @description 页脚组件，通用
 * @author momo
 * @update 2018/12/12
 */
import { platform } from '~/js/utils'

export default {
    name: 'SiteFooter',
    computed: {
        isMobile () {
            return platform.isMobile
        }
    },
    methods: {
        scrollToTop () {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop <= 0) {
                return
            } else {
                window.scrollTo(0, scrollTop - 60)
                requestAnimationFrame(this.scrollToTop)
            }
        }
    }
}
</script>

<style lang="scss">
    /*页脚样式*/
    .site-footer {
        margin-bottom: auto!important;
        text-align: center;
        font-size: 12px;
    }
    .pc {
        .site-footer {
            padding: 24px 0 36px;
            margin-top: 80px;
            border-top: 5px solid #BCBCBC;
            color: #ccc;
            background: #040404 url(../assets/img/footer-bg.jpg) no-repeat center;
            .link {
                a {
                    display: inline-block;
                    margin-left: 12px;
                    color: #ccc;
                    text-decoration: none;
                    font-size: 14px;
                    cursor: pointer;
                }
                a:nth-child(1) {
                    margin-left: auto
                }
            }
            .copyright {
                font-size: 12px;
            }
            .eyougame-logo {
                width: 144px;
                height: auto;
                margin: 20px auto 16px;
            }
            .copyright p {
                line-height: 16px;
            }
        }
    }
    @media(max-width: 768px) {
        /* 页脚手机样式 */
        .site-footer {
            line-height: 0.8rem;
            margin-top: auto;
            font-size: 0.2rem;
            border-top: 1px solid #eee;
            color: #7d7d7d;
            background: #fff;
            .container {
                width: auto;
            }
            .copyright {
                line-height: normal;
                padding: 0.34rem 0
            }
            .eyougame-logo {
                height: 0.56rem;
                margin-bottom: 0.16rem;
            }
            .copyright p {
                line-height: 0.32rem
            }
        }
    }
</style>